import type { BlobDataRequest, BlobDataResponse } from '../blob'
import type { BlobRequestDTO, BlobResponseDTO } from '../dto/blob-dto'

const mapToBlobResponseDTO = (blob: BlobDataResponse): BlobResponseDTO => {
    return {
        path: blob.path,
        url: blob.url,
    }
}

const mapToBlobResponse = (blob: BlobResponseDTO): BlobDataResponse => {
    return {
        path: blob.path ?? undefined,
        url: blob.url ?? undefined,
    }
}

const mapToBlobRequestDTO = (blob: BlobDataRequest): BlobRequestDTO => {
    return {
        Blob: blob.blob,
        Folder: blob.folder,
    }
}

const mapToBlobRequest = (blob: BlobRequestDTO): BlobDataRequest => {
    return {
        blob: blob.Blob,
        folder: blob.Folder,
    }
}

export { mapToBlobRequest, mapToBlobRequestDTO, mapToBlobResponse, mapToBlobResponseDTO }
